export const getTemType = state => state.temType; //类型

